<template>
  <div>
    <div class="pcLogin">
      <div class="login_Head">
        <img v-if="!shuati" style="width: 100%; height: 100%" src="../assets/loginImgs/loginHead@2x.png" />
        <img v-if="shuati" style="width: 100%; height: 100%" src="../assets/img/zyjn.png" />
      </div>
      
      <div class="login_Box">
        <div class="login_Left">
          <div class="title" v-if="shuati">安徽合肥技师学院职业技能认定</div>
          <div class="title" v-if="shuati">模拟练习平台</div>
          <div class="title" v-if="!shuati">职业技能在线考试</div>
          <div class="text_5">专注学员严肃考场 智能判卷防作弊</div>
          <div class="text_6">
            <img class="img_1" src="../assets/loginImgs/login_left_bg@2x.png" alt="" />
          </div>

          <div class="text_3" v-if="!shuati">智能判卷｜人脸核验｜严肃考试</div>
        </div>
        <div class="login_Right">
          <div class="text_2">学员用户登录</div>
          <div class="text_1">账号密码以学习平台发放为主</div>

          <div class="margin58">
            <div style="position: relative">
              <input style="font-family: Regular" class="userIn" type="text" v-model="userInfo.userName" placeholder="请学员输入账号" />
              <img class="img_box" src="../assets/loginImgs/user_icon@2x.png" alt="" />
            </div>

            <div class="margin25">
              <input
                style="font-family: Regular"
                class="userIn"
                type="password"
                v-model="userInfo.userPasswd"
                placeholder="请学员输入密码"
              />
              <img class="img_box" src="../assets/loginImgs/psd_icon@2x.png" alt="" />
            </div>

            <el-button @click="login" class="login_btn" style="">立即登录</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="phoneLogin">
      <div class="login_Head">
        <img
          style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; z-index: -1"
          src="../assets/loginImgs/loginHead@2x.png"
        />
        <div class="headLogoText" v-if="!shuati">职业技能在线考试系统</div>
        <div class="headLogoText sts" v-if="shuati">
          <div>安徽合肥技师学院职业技能认定</div>
          <div>模拟练习平台</div>
        </div>
      </div>

      <div class="loginBox_1" style="display: flex; justify-content: center">
        <div class="ss">
          <div class="headText">登录</div>
          <el-input prefix-icon="el-icon-user-solid" class="userIn" v-model="userInfo.userName" placeholder="请学员输入账号"></el-input>
          <el-input
            prefix-icon="el-icon-s-goods"
            class="userIn"
            show-password
            v-model="userInfo.userPasswd"
            placeholder="请学员输入密码"
          ></el-input>
          <el-button @click="login" class="login_btn" style="">立即登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
console.log(111);
document.addEventListener('fullscreenchange', () => {
  console.log(123);
});
import { mapMutations } from 'vuex';
import { doLogin } from '../api/index';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      userInfo: {
        userName: '', //用户名
        userPasswd: '' //密码
      }, //登录数据
      isFullScreen: false,
      shuati:false,
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data冠成教育的数据变化
  watch: {
    isFullScreen(newOld, oldOld) {
      console.log(newOld, oldOld);
    }
  },
  // 方法集合
  methods: {
    ...mapMutations('m_user', ['updateToken']),
    //登录
    login() {
      if (this.userInfo.userName == '') {
        this.$message('请输入用户名！');
        return false;
      }
      if (this.userInfo.userPasswd == '') {
        this.$message('请输入密码！');
        return false;
      }
      doLogin(this.userInfo).then(res => {
        ////console.log(res);
        if (res.data.token) {
          this.updateToken(res.data.token);
          //拿到密钥存在本地存储
          localStorage.setItem('token', res.data.token);

          //提示成功
          this.$message({
            message: '登录成功!',
            type: 'success'
          });

          if (this.$route.query.shuati) {
            this.$router.push({
              path: '/st',
              query: {
                shuati: true
              }
            });
          } else {
            //跳转到选工种页面
            if (document.documentElement.RequestFullScreen) {
              document.documentElement.RequestFullScreen();
            }
            //兼容火狐
            console.log(document.documentElement.mozRequestFullScreen);
            if (document.documentElement.mozRequestFullScreen) {
              document.documentElement.mozRequestFullScreen();
            }
            //兼容谷歌等可以webkitRequestFullScreen也可以webkitRequestFullscreen
            if (document.documentElement.webkitRequestFullScreen) {
              document.documentElement.webkitRequestFullScreen();
            }
            //兼容IE,只能写msRequestFullscreen
            if (document.documentElement.msRequestFullscreen) {
              document.documentElement.msRequestFullscreen();
            }
            this.$router.push({ path: '/lsitFs' });
          }
        } else {
          //登录失败
          this.$message({
            message: '账号或密码错误!',
            type: 'error'
          });
        }
      });
    },
    judegIsFullScreen() {
      window.onresize = () => {
        // 可视区域的高度
        const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
        // screen是window的属性方法，window.screen可省略window，指的是窗口
        this.isFullScreen = screen.height == clientHeight;
      };
    },
    // 监听键盘
    keyDown() {
      document.onkeydown = e => {
        console.log(e, e.key);
        if (e.key == 'Escape') {
          // e.preventDefault()
          alert('禁止退出全屏');
        }
      };
    },
    quanping() {
      this.RequestFullScreen = true;
      if (document.documentElement.RequestFullScreen) {
        document.documentElement.RequestFullScreen();
      }
      //兼容火狐
      console.log(document.documentElement.mozRequestFullScreen);
      if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      }
      //兼容谷歌等可以webkitRequestFullScreen也可以webkitRequestFullscreen
      if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen();
      }
      //兼容IE,只能写msRequestFullscreen
      if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      }
    },
    jianting() {
      document.addEventListener('fullscreenchange', () => {
        console.log(document.documentElement.RequestFullScreen);
        if (document.documentElement.RequestFullScreen) {
          this.$nextTick(() => {
            // 这里对全屏后样式进行操作
            console.log(123);
          });
        }
      });
    },
    daonload(name) {
      fetch(this.url)
        .then(res => res.blob())
        .then(blob => {
          const a = document.createElement('a');
          const objectUrl = window.URL.createObjectURL(blob);
          a.download = name;
          a.href = objectUrl;
          a.click();
          window.URL.revokeObjectURL(objectUrl);
          a.remove();
        });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query.shuati) {
      this.shuati = true
    }else {
      this.shuati = false
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.keyDown();
    this.judegIsFullScreen();
    localStorage.setItem('height1', document.documentElement.clientHeight);
    localStorage.setItem('height2', document.body.clientHeight);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less">
/* //@import url(); 引入公共css类 */
@media (min-width: 768px) {
  .phoneLogin {
    display: none;
  }
  .text_6 {
    text-align: center;
    margin-top: 12px;
  }
  .title {
    font-size: 22px;
    color: #272748;
    text-align: center;
    font-family: bold;
  }
  .img_1 {
    width: 248px;
    height: 248px;
  }
  .text_5 {
    margin-top: 8px;
    font-size: 16px;
    color: #272748;
    text-align: center;
    font-family: Regular;
  }
  .text_3 {
    text-align: center;
    margin-top: 5px;
    font-family: Regular;
    font-size: 14px;
  }
  .text_2 {
    font-size: 22px;
    color: #272748;
    font-family: bold;
  }
  .text_1 {
    margin-top: 8px;
    font-size: 14px;
    color: #272748;
    font-family: Regular;
  }
  .margin25 {
    position: relative;
    margin-top: 25px;
  }
  .margin58 {
    margin-top: 58px;
  }
  .img_box {
    width: 16px;
    height: 16px;
    position: absolute;
    left: 20px;
    top: 17px;
  }
  .login_btn {
    font-family: Regular;
    margin-top: 57px;
    background: #4275f5;
    border-radius: 12px;
    width: 300px;
    height: 50px;
    color: #fff;
    font-size: 16px;
  }
  .login_Head {
    width: 100%;
    height: 250px;
  }
  .login_Box {
    position: absolute;
    top: 155px;
    left: 50%;
    transform: translateX(-50%);
    width: 760px;
    height: 445px;
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(160, 160, 160, 0.16);
    opacity: 1;
    border-radius: 20px;
    display: flex;
    overflow: hidden;
    .login_Left {
      width: 50%;
      background: url('../assets/loginImgs/login_left@2x.png') 100% 100%;
      padding: 50px 0 0 0;
    }
    .login_Right {
      width: 50%;
      padding: 50px 0 0 40px;
    }
    .userIn {
      padding-left: 48px;
      width: 300px;
      height: 50px;
      background: #f0f3f7;
      opacity: 1;
      border-radius: 12px;
      border: 0;
      font-size: 14px;
    }
  }
}
//移动
@media (max-width: 768px) {
  .phoneLogin {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: #f5f5f5;
  }
  .pcLogin {
    display: none;
  }
  .login_Head {
    position: relative;
    width: 100%;
    height: 200px;
  }
  .userIn {
    width: 300px;
    margin-top: 10px;
    opacity: 1;
    border-radius: 12px;
    border: 0;
    font-size: 14px;
  }

  .headLogoText {
    font-size: 25px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 200px;
  }
  .sts {
    padding-top: 50px;
    line-height: 40px !important;
  }
  .ss {
    position: absolute;
    top: 142px;
    width: 330px;
    height: 250px;
    padding: 15px;
    border-radius: 12px;
    background: #fff;
    margin-top: 20px;
    z-index: 3;
    .headText {
      font-weight: bold;
      color: #333;
      text-align: center;
      font-size: 16px;
    }
  }
  .login_btn {
    font-family: Regular;
    margin-top: 17px;
    background: #4275f5;
    border-radius: 12px;
    width: 300px;
    height: 50px;
    color: #fff;
    font-size: 16px;
  }
}
</style>
